<template>
    <div>
        <div class="text-right ml-auto mb-4" style="position: sticky; top: 0px; z-index: 99; width: fit-content">
            <button class="btn btn-common-cancel mr-3" @click="handleCancel">{{ $t('btn.cancel') }}</button>
            <button class="btn btn-common btn-success" @click="handleSave">{{ $t('btn.save') }}</button>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                >{{ $t('landingPage.settingFreeBlock.title') }} <span class="text-danger">*</span></label
            >
            <div class="col-sm-8">
                <InputText
                    :model.sync="cinitForm.title"
                    :config.sync="configFormTitleFreeBlock.configFieldTitle"
                    @blur="handleValidateField(configFormTitleFreeBlock.configFieldTitle)"
                />
                <div class="mt-3">
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                        <div class="col-sm-3">
                            <div class="d-flex align-items-center" style="gap: 0.5rem">
                                <InputText
                                    style="max-width: 120px"
                                    :model.sync="cinitForm.size_title"
                                    :config.sync="configFormTitleFreeBlock.configFieldSizeTitle"
                                />
                                <span>px</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                        <div class="col-sm-5">
                            <div class="d-flex" style="gap: 1rem">
                                <InputText
                                    style="min-width: 100px"
                                    :model.sync="cinitForm.color_title"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                />
                                <InputText
                                    style="max-width: 100px"
                                    :model.sync="cinitForm.color_title"
                                    :config="{
                                        error: false
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                        <div class="col-sm-5">
                            <div class="d-flex" style="gap: 1rem">
                                <InputText
                                    style="min-width: 100px"
                                    :model.sync="cinitForm.background_title"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                />
                                <InputText
                                    style="max-width: 100px"
                                    :model.sync="cinitForm.background_title"
                                    :config="{
                                        error: false
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFreeBlock.category') }} </label>
            <div class="col-sm-8">
                <div class="d-flex flex-wrap" style="gap: 1rem">
                    <div v-for="item in LIST_STYLE_FREE_BLOCK" :key="item.id + 's'">
                        <InputRadio
                            class="mr-4"
                            :model.sync="cinitForm.style"
                            :name="`block-free-style`"
                            :id="`block-free-style-${item.id}`"
                            :value="item"
                            :label="item.name"
                            @change="onHandleTranferShotCode('select')"
                        />
                        <div class="mt-2" style="width: 100px; height: 80px">
                            <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFreeBlock.detail') }} </label>
            <div class="col-sm-8">
                <Editor
                    :id="`ActionTitleFree`"
                    :model.sync="cinitForm.html_content"
                    :modelEvents="`change keydown blur focus paste`"
                    :configInit="configEditor"
                    @init="onEditorInit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputText, InputRadio } from '@/components/Input';
import { configFormTitleFreeBlock } from '../constants';
import { validateField, validateAllField } from '@/utils/validate';
import { LIST_STYLE_FREE_BLOCK } from '../../../styles';
import { onHandleChangeTemp, mapImageDefault } from '../../../handlers';

import Editor from '@/components/Editor/main.vue';

export default {
    name: 'ActionFreeBlock',
    components: {
        InputText,
        InputRadio,
        Editor
    },
    props: {
        dataFreeBlock: {
            type: Array,
            default: () => []
        },
        objFree: {
            type: Object,
            default: () => {}
        }
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage'])
        })
    },
    data() {
        return {
            configFormTitleFreeBlock: configFormTitleFreeBlock,
            LIST_STYLE_FREE_BLOCK: mapImageDefault(LIST_STYLE_FREE_BLOCK),
            cinitForm: this.initForm(),
            configEditor: {
                height: 500,
                content_style: ''
            }
        };
    },

    methods: {
        initForm() {
            return {
                key_parent: '',
                title: '',
                size_title: '',
                color_title: '',
                background_title: '',
                style: null,
                html_content: ''
            };
        },
        handleValidateField(configField) {
            validateField(configField);
        },

        handleCancel() {
            let { configFieldTitle } = this.configFormTitleFreeBlock;
            configFieldTitle.error = false;
            this.$emit('cancel');
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        },

        handleSave() {
            let check = validateAllField(configFormTitleFreeBlock);
            if (!check) return;
            this.$emit('save', this.cinitForm);
        },

        onHandleTranferShotCode(type = null) {
            let { style } = this.cinitForm;
            if (!style) return;
            let addProper = '';
            if (type === 'select') {
                this.cinitForm.html_content = '';
                this.objEditor.setContent('');
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
                this.configEditor.content_style = style?.cssStyle;
            }
            if (!this.cinitForm.html_content) {
                addProper = style?.contents;
            } else {
                const div = document.createElement('div');
                div.innerHTML = this.cinitForm.html_content;
                const sourceBgrElement = div.querySelector('.content--free__block');
                addProper = sourceBgrElement.outerHTML;
            }
            this.cinitForm.html_content = addProper;
        },

        updateEditorStyle(editor, newCss) {
            const head = editor.contentDocument.head || editor.getDoc().head;
            let styleTag = head.querySelector('#dynamic-editor-style');
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = 'dynamic-editor-style';
                head.appendChild(styleTag);
            }
            styleTag.innerHTML = newCss;
        }
    },
    watch: {
        objFree: {
            handler: function (newObj) {
                let { key_parent, name } = newObj;
                const foundObj = this.dataFreeBlock?.find((otp) => otp.key_parent === key_parent);
                if (foundObj) {
                    this.cinitForm = {
                        ...this.cinitForm,
                        ...foundObj,
                        size_title: foundObj?.size_title ?? '24',
                        html_content: foundObj?.html_content ?? ''
                    };
                } else {
                    this.cinitForm = {
                        ...this.cinitForm,
                        title: name,
                        size_title: '24',
                        key_parent
                    };
                }
            },
            immediate: true
        }
    },
    mounted() {
        setTimeout(() => {
            let { style } = this.cinitForm;
            if (style) {
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
                return;
            }
            let checkTem = onHandleChangeTemp(this.infoSettingLandingPage, this.cinitForm, this.LIST_STYLE_FREE_BLOCK);
            if (checkTem) {
                this.onHandleTranferShotCode('select');
            } else {
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
            }
        }, 500);
    }
};
</script>

<style lang="scss" scoped></style>
